<template>
  <div class="sf-page">
    <top-header v-bind:title="$t('addSupplier')">
      <v-btn class="sf-back-btn"
             exact
             slot="left-button"
             text
             v-bind:to="{ name: 'administration-suppliers' }">
        <v-icon left>ti-arrow-left</v-icon>
        {{ $t('back') }}
      </v-btn>
      <v-btn color="primary"
             depressed
             exact
             slot="right-button"
             v-on:click="createSupplier">
        <v-icon left>ti-check</v-icon>
        {{ $t('add') }}
      </v-btn>
    </top-header>
    <div class="sf-container">
      <v-alert class="sf-alert"
               text
               type="error"
               v-model="validationAlert">
        {{ $t('pleaseCompleteTheForm') }}
      </v-alert>
      <v-row>
        <v-col cols="12"
               lg="8">
          <supplier-edit-card ref="supplierEditForm"
                              v-bind:supplier="supplier" />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
  import SupplierEditCard from '@/components/administration/SupplierEditCard'
  import TopHeader from '@/components/common/TopHeader'

  export default {
    components: {
      SupplierEditCard,
      TopHeader
    },
    data: () => ({
      supplier: {
        state: 'open'
      },
      validationAlert: false
    }),
    methods: {
      async createSupplier() {
        if (!this.$refs.supplierEditForm.validate()) {
          this.validationAlert = true
          this.$vuetify.goTo(0)

          return
        }

        await this.$store.dispatch('createSupplier', { supplier: this.supplier })

        this.$router.push({ name: 'administration-supplier', params: { id: this.supplier.id } })
      }
    },
    name: 'AddSupplier'
  }
</script>

<i18n>
  {
    "de": {
      "add": "Hinzufügen",
      "addSupplier": "Lieferant hinzufügen",
      "back": "Zurück",
      "pleaseCompleteTheForm": "Bitte vervollständigen Sie Ihre Angaben."
    },
    "en": {
      "add": "Add",
      "addSupplier": "Add supplier",
      "back": "Back",
      "pleaseCompleteTheForm": "Please complete the form."
    }
  }
</i18n>